
import React, { useState, useEffect } from "react";
import { FaUsers, FaShoppingCart, FaHistory, FaUndo, FaSearch, FaPlus } from "react-icons/fa";
import { MdPersonAddAlt1 } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import { showSuccess, showError, showWarning } from "../../General/Toast";
import { IoEye } from "react-icons/io5";
import { MdVerifiedUser, MdPersonOff, MdCurrencyRupee } from "react-icons/md";
import { toast } from "react-toastify";
import { CiEdit } from "react-icons/ci";



const Purchase = ({ clientData }) => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("overview");
  const [showPartyForm, setShowPartyForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');

  const [selectedParty, setSelectedParty] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editingCompanyId, setEditingCompanyId] = useState(null);
  const [party, setParty] = useState([]);
  const [purchaseBill, setPurchaseBill] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedPurchase, setSelectedPurchase] = useState(null);

  const [invoiceSearch, setInvoiceSearch] = useState("");
  const [partySearchTerm, setPartySearchTerm] = useState("");



  const [showTxn, setShowTxn] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    first_visit: '',
    last_visit: '',
    mobile: '',
    email: "",
    total_pur: "",
    total_due: "",
    loyality: '',
    visits: "",
    gstin: '',
    gst_type: "Registered",
    gst_state: '',
    address: '',
    history: '',
    opening_balance: '',
    opening_bal_status: '',
    balance: '',
    asOfDate: '',
    p_type: '',
    client_id: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData(prev => {
      const updated = { ...prev, [name]: value };

      return updated;
    });
  };

  const today = new Date().toISOString().split("T")[0];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.mobile) {
      showWarning("Name and Mobile are required!", "danger");
      return;
    }

    try {
      const today = new Date().toISOString().split("T")[0];


      const sendData = {
        name: formData.name,
        mobile: formData.mobile,
        gstin: formData.gstin,
        email: formData.email,

        gst_type: formData.gst_type,
        gst_state: formData.gst_state,
        address: formData.address,
        opening_balance: formData.opening_balance,
        asOfDate: formData.asOfDate,
        p_type: "Party",
        client_id: clientData.id,
        first_visit: today,
        last_visit: today,
        total_pur: 0,
        total_due: 0,
        loyality: 0,
        visits: 0,
        opening_bal_status: '',
        balance: 0,
      };

      let res;

      // 🔥 EDIT MODE
      if (isEditMode) {

        const updateData = {
          name: formData.name,
          mobile: formData.mobile,
          gstin: formData.gstin,
          email: formData.email,
          gst_type: formData.gst_type,
          gst_state: formData.gst_state,
          address: formData.address,
        };

        res = await axios.put(
          `https://api.dectwinbilling.com/edit-party/${formData.id}`,
          updateData
        );

        showSuccess("Party Updated Successfully!", "success");
      } else {
        // 🔥 ADD MODE
        res = await axios.post(
          "https://api.dectwinbilling.com/add-party",
          sendData
        );

        showSuccess("Party Added Successfully!", "success");
      }

      // reset
      setIsEditMode(false);
      resetForm();
      setShowPartyForm(false);
      fetchparty();

    } catch (err) {
      console.error("❌ Error:", err.response?.data || err.message);

      showError(
        err.response?.data?.message || "Failed to save party!",
        "danger"
      );
    }
  };

  const handleEdit = (form) => {

    setIsEditMode(true);
    setShowPartyForm(true);

    setFormData({
      id: form.id,
      name: form.name || "",
      mobile: form.mobile || "",
      email: form.email || "",
      gstin: form.gstin || "",
      gst_type: form.gst_type || "",
      gst_state: form.gst_state || "",
      address: form.address || "",
      opening_balance: form.opening_balance || "",
      asOfDate: form.as_of_date || "",
    });
  };


  const fetchparty = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-party/${clientData.id}`);
      setParty(res.data);

    } catch (error) {
      console.log(error);
    }
  };

  const fetchPurchase = async () => {
    try {
      const res = await axios.get(`https://api.dectwinbilling.com/fetch-purchase-bill/${clientData.id}`);
 
      const sortedData = [...res.data].sort((a, b) => b.id - a.id);
      setPurchaseBill(sortedData);

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchparty();
    fetchPurchase();
  }, []);

  const resetForm = () => {
    setFormData({
      name: '',
      first_visit: '',
      last_visit: '',
      mobile: '',
      email: "",
      total_pur: "",
      total_due: "",
      loyality: '',
      visits: "",
      gstin: '',
      gst_type: '',
      gst_state: '',
      address: '',
      history: '',
      opening_balance: '',
      opening_bal_status: '',
      balance: '',
      asOfDate: '',
      p_type: '',
      client_id: ''
    })



  }

  const filteredData = Array.isArray(party)
    ? party
      .filter((itm) =>
        Object.values(itm).some((val) =>
          String(val).toLowerCase().includes(searchTerm.toLowerCase())
        )
      )
    : [];

  const filteredPrucase = Array.isArray(purchaseBill)
    ? purchaseBill.filter((itm) => {
      const search = partySearchTerm.toLowerCase();
      const invoice = invoiceSearch.toLowerCase();

      const matchGlobal =
        itm.name?.toLowerCase().includes(search) ||
        itm.mobile?.toLowerCase().includes(search) ||
        itm.client_type?.toLowerCase().includes(search);

      const matchInvoice =
        invoice === ""
          ? true
          : String(itm.id || "")
            .toLowerCase()
            .includes(invoice);

      return matchGlobal && matchInvoice;
    })
    : [];



  const handleViewItems = (purchase) => {
    setSelectedPurchase(purchase);
    setShowModal(true);
  };

  const itemList = selectedPurchase?.items
    ? JSON.parse(selectedPurchase.items)
    : [];
// const handleAddPurchaseItems = async (purchase) => {
//   try {

//     if (!purchase || !purchase.invoiceNo) {
//       toast.error("Invoice number not found.");
//       return;
//     }

//     if (Number(purchase.itemsAdded) === 1) {
//       toast.warning("Items already added.");
//       return;
//     }

//     const parsedItems =
//       typeof purchase.items === "string"
//         ? JSON.parse(purchase.items)
//         : purchase.items;

//     const updatedItems = parsedItems.map((item) => ({
//       ...item,

//       // Purchase quantity
//       qty: Number(item.qty || 0),
//     }));

//     console.log(
//       "PURCHASE ITEMS SENT:",
//       updatedItems
//     );

//     await axios.put(
//       `https://api.dectwinbilling.com/add-purchase-item/${clientData.id}`,
//       {
//         invoiceNo: purchase.invoiceNo,

//         items: updatedItems,

//         itemsAdded: 1,
//       }
//     );

//     toast.success(
//       "Items added to inventory successfully."
//     );

//     await fetchPurchase();

//   } catch (err) {

//     console.error(
//       "Add purchase items error:",
//       err.response?.data || err
//     );

//     toast.error(
//       err.response?.data?.message ||
//       "Failed to add items."
//     );
//   }
// };
// const handleAddPurchaseItems = async (purchase) => {
//   try {
//     if (!purchase || !purchase.invoiceNo) {
//       toast.error("Invoice number not found.");
//       return;
//     }

//     // Prevent double click
//     if (Number(purchase.itemsAdded) === 1) {
//       toast.warning("Items already added.");
//       return;
//     }

//     await axios.put(
//       `https://api.dectwinbilling.com/add-purchase-item/${clientData.id}`,
//       {
//         invoiceNo: purchase.invoiceNo,
//         items: purchase.items,
//         itemsAdded: 1,
//       }
//     );

//     toast.success("Items added to inventory successfully.");

//     // Refresh purchase list
//     await fetchPurchase();

//   } catch (err) {
//     console.error(
//       "Add purchase items error:",
//       err.response?.data || err
//     );

//     toast.error(
//       err.response?.data?.message ||
//       "Failed to add items."
//     );
//   }
// };
//     const handleAddPurchaseItems = async (purchase) => {
//   try {
//     await axios.put(
//       `https://api.dectwinbilling.com/add-purchase-item/${clientData.id}`,
//       {
//         invoiceNo: purchase.invoiceNo,
//         items: purchase.items,
//         itemsAdded: 1,
//       }
//     );

//     toast.success("Items added successfully.");



//  fetchPurchase();

//   } catch (err) {
//     console.error(err);
//     toast.error("Failed to add items.");
//   }
// };
const handleAddPurchaseItems = async (purchase) => {
  try {

    if (!purchase || !purchase.invoiceNo) {
      toast.error("Invoice number not found.");
      return;
    }

    if (Number(purchase.itemsAdded) === 1) {
      toast.warning("Items already added.");
      return;
    }

    const parsedItems =
      typeof purchase.items === "string"
        ? JSON.parse(purchase.items)
        : purchase.items;

    const updatedItems = parsedItems.map((item) => ({
      ...item,

      // ONLY PURCHASE QUANTITY
      qty: Number(item.qty || 0),
    }));

    console.log(
      "ITEMS SENT TO BACKEND:",
      updatedItems
    );

    await axios.put(
      `https://api.dectwinbilling.com/add-purchase-item/${clientData.id}`,
      {
        invoiceNo: purchase.invoiceNo,
        items: updatedItems,
        itemsAdded: 1,
      }
    );

    toast.success(
      "Purchase items added successfully."
    );

    await fetchPurchase();

  } catch (err) {

    console.error(
      "Add purchase items error:",
      err.response?.data || err
    );

    toast.error(
      err.response?.data?.message ||
      "Failed to add items."
    );
  }
};
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#dce8f4",
        padding: "15px",
        gap: "20px",

      }}
    >
      <div
        style={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "15px",
          marginBottom: "20px",
        }}
      >
        <MenuCard
          title="Party Overview"
          icon={<FaUsers size={35} />}
          bg="linear-gradient(135deg,#ff8a8a,#ff6d8d)"
          active={activeTab === "overview"}
          onClick={() => setActiveTab("overview")}
        />

        <div>
          <MenuCard
            title="Add Purchase"
            icon={<FaShoppingCart size={35} />}
            bg="linear-gradient(135deg,#d86cff,#7367f0)"
            active={activeTab === "addPurchase"}
            onClick={() => {
              setActiveTab("addPurchase");
              navigate("/Addpurchase");
            }}
          />
        </div>

        <MenuCard
          title="Purchase History"
          icon={<FaHistory size={35} />}
          bg="linear-gradient(135deg,#39d4d4,#1aa7d1)"
          active={activeTab === "history"}
          onClick={() => setActiveTab("history")}
        />
        <MenuCard
          title="Purchase Return"
          icon={<FaUndo size={35} />}
          bg="linear-gradient(135deg,#7caeff,#6a6ee6)"
          active={activeTab === "purchaseReturn"}
          onClick={() => {
            setActiveTab("purchaseReturn");
            navigate("/purchaseReturn");
          }}
        />
      </div>

      <div
        style={{
          width: "100%",
          background: "#fff",
          borderRadius: "25px",
          overflow: "hidden",
        }}
      >
        {activeTab === "overview" ? (
          <>
            <div
              className="d-flex justify-content-between align-items-center flex-wrap"
              style={{
                padding: "20px",
              }}
            >
              {/* LEFT SIDE */}
              <div>
                <div
                  className="d-flex align-items-center gap-2"
                  style={{
                    fontSize: "25px",
                    fontWeight: "bold",
                    color: "#ff6d8d",
                  }}
                >
                  <MdPersonAddAlt1 size={26} />
                  PARTIES
                </div>

                <small className="text-muted">
                  Manage your suppliers & create new ones.
                </small>
              </div>

              {/* RIGHT SIDE */}
              <button
                className="add-party-btn"
                onClick={() => (
                  setShowPartyForm(true),
                  setIsEditMode(false)
                )}
              >
                <FaPlus />
                Add Party
              </button>
            </div>



            <div className="row px-3 mb-3">


              <div className="col-md-3 col-6 mb-2">
                <div className="card shadow-sm border-start border-1 border-primary  bg-opacity-10">

                  <div className="card-body d-flex align-items-center justify-content-between">

                    {/* ICON */}
                    <div className="d-flex align-items-center justify-content-center bg-primary bg-opacity-25 text-primary rounded-circle"
                      style={{ width: "55px", height: "55px", fontSize: "22px" }}
                    >
                      <MdPersonAddAlt1 />
                    </div>

                    {/* TEXT */}
                    <div className="text-end">
                      <h6 className="text-muted mb-1">Total Parties</h6>
                      <h4 className="fw-bold text-primary mb-0">
                        {party.length}
                      </h4>
                    </div>

                  </div>
                </div>
              </div>


              <div className="col-md-3 col-6 mb-2">
                <div className="card shadow-sm border-start border-1 border-success  bg-opacity-10">

                  <div className="card-body d-flex align-items-center justify-content-between">

                    <div className="d-flex align-items-center justify-content-center bg-success bg-opacity-25 text-success rounded-circle"
                      style={{ width: "55px", height: "55px", fontSize: "22px" }}
                    >
                      <MdVerifiedUser />
                    </div>

                    <div className="text-end">
                      <h6 className="text-muted mb-1">Registered</h6>
                      <h4 className="fw-bold text-success mb-0">
                        {party.filter(p => p.gst_type === "Registered").length}
                      </h4>
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-md-3 col-6 mb-2">
                <div className="card shadow-sm border-start border-1 border-warning  bg-opacity-10">

                  <div className="card-body d-flex align-items-center justify-content-between">

                    <div className="d-flex align-items-center justify-content-center bg-warning bg-opacity-25 text-warning rounded-circle"
                      style={{ width: "55px", height: "55px", fontSize: "22px" }}
                    >
                      <MdPersonOff />
                    </div>

                    <div className="text-end">
                      <h6 className="text-muted mb-1">Unregistered</h6>
                      <h4 className="fw-bold text-warning mb-0">
                        {party.filter(p => p.gst_type === "Unregistered").length}
                      </h4>
                    </div>

                  </div>
                </div>
              </div>

              <div className="col-md-3 col-6 mb-2">
                <div className="card shadow-sm border-start border-1 border-danger  bg-opacity-10">

                  <div className="card-body d-flex align-items-center justify-content-between">

                    <div className="d-flex align-items-center justify-content-center bg-danger bg-opacity-25 text-danger rounded-circle"
                      style={{ width: "55px", height: "55px", fontSize: "22px" }}
                    >
                      <MdCurrencyRupee />
                    </div>

                    <div className="text-end">
                      <h6 className="text-muted mb-1">Total Due</h6>
                      <h4 className="fw-bold text-danger mb-0">
    ₹
    {party
      .reduce(
        (sum, p) => sum + Number(p.total_due || 0),
        0
      )
      .toFixed(2)}
  </h4>
                    </div>

                  </div>
                </div>
              </div>

            </div>

            <div className="px-3 mb-3">
              <div className="d-flex align-items-center gap-2 border border-success rounded px-3 py-2 bg-white shadow-sm">

                <FaSearch className="text-success" />

                <input
                  type="text"
                  placeholder="Search by name, mobile, GSTIN..."
                  className="form-control border-0 shadow-none"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>

            <div className="px-3">
              <div className="table-responsive bg-white shadow-sm rounded">

                <table className="table table-hover mb-0">

                  {/* HEADER */}
                  <thead className=" text-dark">
                    <tr>
                      <th>SN</th>
                      <th>Name</th>
                      <th>Mobile</th>
                      <th>GST Type</th>
                      <th>GSTIN</th>
                      <th>Total Purchase</th>
                      <th>Total Due</th>
                      <th>Activity</th>
                    </tr>
                  </thead>

                  {/* BODY */}
                  <tbody>
                    {filteredData.length === 0 ? (
                      <tr>
                        <td colSpan="7" className="text-center text-muted py-4">
                          No Party Found
                        </td>
                      </tr>
                    ) : (
                      filteredData.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.name}</td>
                          <td>{item.mobile}</td>
                          <td>
                            {item.gst_type === "Registered" ? (
                              <span className="badge bg-success">
                                Registered
                              </span>
                            ) : (
                              <span className="badge bg-danger">
                                Unregistered
                              </span>
                            )}
                          </td>
                          <td>{item.gstin}</td>
                          <td> {item.total_pur} </td>
                          <td>{item.total_due} </td>
                          <td>
                            <button
                              className="btn btn-sm  me-2"
                              onClick={() => handleEdit(item)}
                            >
                              <IoEye size={26} text-secondry />
                            </button>




                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>

                </table>
              </div>
            </div>

            {/* party Form */}
            <div className="party-content">
              {/* {showPartyForm && (
  <div className="party-modal-overlay">
 <form onSubmit={handleSubmit}> 
    <div className="party-modal">

      <button
        className="close-btn"
        onClick={() => setShowPartyForm(false)}
      >
        ×
      </button>

      <h1 className="modal-title">ADD PARTY</h1>
      <h3>Enter Party Details:</h3>

      <div className="party-form-grid">

        <div className="form-column">
          <div className="form-group">
            <label>Party Name *</label>
            <input type="text" placeholder="Enter Name"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="form-control"
              required            
            
            />
          </div>

          <div className="form-group">
            <label>Party Contact *</label>
            <input type="number" placeholder="Enter Number" 
              name="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
              className="form-control"
              maxLength={10}
              required
        
            />
          </div>

          <div className="form-group">
            <label>Party GSTIN *</label>
            <input type="text" placeholder="Enter GSTIN"
              name="gstin"
              value={formData.gstin}
              onChange={handleInputChange}
              className="form-control"
            
            />
          </div>

          <div className="form-group">
            <label>Party Email</label>
            <input type="email" placeholder="Enter Email" 
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="form-control"
              required
            />
          </div>
        </div>

        <div className="form-column">
          <div className="form-group">
            <label>GSTIN Type</label>

            <select 
             name="gst_type"
  value={formData.gst_type}
  onChange={handleInputChange}
  required >
             <option>Select</option>
              <option>Registered</option>
              <option>Unregistered</option>
            </select>
          </div>

          <div className="form-group">
            <label>GSTIN State *</label>
            <input type="text" placeholder="Enter State" 
             name="gst_state"
              value={formData.gst_state}
              onChange={handleInputChange}
              className="form-control"
              required
            />
          </div>

          <div className="form-group">
            <label>GSTIN Address *</label>
            <textarea placeholder="Enter Address" 
             name="address"
              value={formData.address}
              onChange={handleInputChange}
              className="form-control"
              required
            ></textarea>
          </div>
        </div>
      </div>

      <h3>Credit & Balance</h3>

      <div className="party-form-grid">
        <div className="form-group">
          <label>Opening Balance</label>
          <input type="number" placeholder="Opening Balance" 
           name="opening_balance"
              value={formData.opening_balance}
              onChange={handleInputChange}
              className="form-control"
             disabled={isEditMode}
          />
        </div>

        <div className="form-group">
          <label>As of Date</label>
          <input type="datetime-local" 
           name="asOfDate"
              value={formData.asOfDate}
              onChange={handleInputChange}
              className="form-control"
              required
          />
        </div>

            <div className="form-group">
          <label>Total Purchase </label>
          <input type="number" 
           name="total_pur"
              value={formData.total_pur || 0}
              onChange={handleInputChange}
              className="form-control"
              disabled={isEditMode}
          />
        </div>
            <div className="form-group">
          <label className="text-danger">Total Due</label>
          <input type="number" 
           name="total_due"
              value={formData.total_due || 0}
              onChange={handleInputChange}
              className="form-control"
              disabled={isEditMode}
          />
        </div>
      </div>

  <div className="submit-area">
  <button className="submit-btn" type="submit">
    {isEditMode ? "Update Details" : "Submit Details"}
  </button>
</div>

    </div>

</form>
  </div>
)} */}

             {showPartyForm && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    role="dialog"
    aria-modal="true"
    style={{
      backgroundColor: "rgba(0, 0, 0, 0.55)",
    }}
  >
    <form onSubmit={handleSubmit}>
      <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg px-2">
        <div className="modal-content border-0 shadow-lg rounded-4">

          {/* =====================================================
              HEADER
          ====================================================== */}
          <div className="modal-header px-4 py-3">

            <h5
              className="modal-title fw-bold mb-0"
              style={{
                color: "#2583e8",
              }}
            >
              {isEditMode ? "Edit Party" : "Party Details"}
            </h5>

            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={() => {
                setShowPartyForm(false);
                setIsEditMode(false);
                resetForm();
              }}
            />

          </div>


          {/* =====================================================
              BODY
          ====================================================== */}
          <div className="modal-body px-4 py-3">

            <div className="row g-3">

              {/* =================================================
                  LEFT SECTION
              ================================================== */}
              <div className="col-12 col-md-6">

                {/* PARTY NAME */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Party Name :
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />

                </div>


                {/* PARTY CONTACT */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Party Contact :
                  </label>

                  <input
                    type="text"
                    className="form-control"
                    name="mobile"
                    value={formData.mobile}
                    onChange={handleInputChange}
                    required
                    maxLength={10}
                  />

                </div>


                {/* PARTY GSTIN */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Party GSTIN :
                  </label>
{/* 
                  <input
                    type="text"
                    className="form-control"
                    name="gstin"
                    value={formData.gstin}
                    onChange={handleInputChange}
                  /> */}
                  <input
  type="text"
  className="form-control"
  name="gstin"
  value={formData.gstin}
  onChange={handleInputChange}
  disabled={formData.gst_type === "Unregistered"}
/>

                </div>


                {/* PARTY EMAIL */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Party Email :
                  </label>

                  <input
                    type="email"
                    className="form-control"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                  />

                </div>


                {/* TOTAL PURCHASE */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Total Purchase :
                  </label>

                  <div className="form-control bg-light">
                    {formData.total_pur || 0}
                  </div>

                </div>


                {/* OPENING BALANCE */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    Opening Bal :
                  </label>

                  <input
                    type="number"
                    className="form-control"
                    name="opening_balance"
                    value={formData.opening_balance}
                    onChange={handleInputChange}
                    disabled={isEditMode}
                  />

                </div>

              </div>


              {/* =================================================
                  RIGHT SECTION
              ================================================== */}
              <div className="col-12 col-md-6">

                {/* GST TYPE */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    GSTIN Type :
                  </label>
<select
  className="form-select"
  name="gst_type"
  value={formData.gst_type}
  onChange={handleInputChange}
>
  <option value="">Select</option>

  <option value="Registered">
    Registered
  </option>

  <option value="Unregistered">
    Unregistered
  </option>
</select>

                </div>


                {/* GST STATE */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    GSTIN State :
                  </label>

                  {/* <input
                    type="text"
                    className="form-control"
                    name="gst_state"
                    value={formData.gst_state}
                    onChange={handleInputChange}
                  /> */}
                  <input
  type="text"
  className="form-control"
  name="gst_state"
  value={formData.gst_state}
  onChange={handleInputChange}
  disabled={formData.gst_type === "Unregistered"}
/>

                </div>


                {/* GST ADDRESS */}
                <div className="mb-3">

                  <label className="form-label fw-semibold mb-1">
                    GSTIN Address :
                  </label>

               <textarea
  className="form-control"
  name="address"
  value={formData.address}
  onChange={handleInputChange}
  rows="3"
  disabled={formData.gst_type === "Unregistered"}
/>

                </div>


                {/* TOTAL DUE - EDIT MODE */}
                {isEditMode && (
                  <div className="mb-3">

                    <label className="form-label fw-semibold text-danger mb-1">
                      Total Due :
                    </label>

                    <input
                      type="number"
                      className="form-control bg-light text-danger fw-semibold"
                      name="total_due"
                      value={formData.total_due || 0}
                      disabled
                    />

                  </div>
                )}


                {/* AS OF DATE - ADD MODE */}
                {!isEditMode && (
                  <div className="mb-3">

                    <label className="form-label fw-semibold mb-1">
                      As Of Date :
                    </label>

                    <input
                      type="datetime-local"
                      className="form-control"
                      name="asOfDate"
                      value={formData.asOfDate}
                      onChange={handleInputChange}
                      required
                    />

                  </div>
                )}

              </div>

            </div>

          </div>


          {/* =====================================================
              FOOTER
          ====================================================== */}
         {/* =====================================================
    FOOTER
===================================================== */}
<div className="border-top px-4 py-3">

  <div className="row align-items-center justify-content-between">

    {/* LEFT - CLOSE */}
    <div className="col-auto">
      <button
        type="button"
        className="btn btn-secondary px-4"
        onClick={() => {
          setShowPartyForm(false);
          setIsEditMode(false);
          resetForm();
        }}
      >
        Close
      </button>
    </div>


    {/* RIGHT - SUBMIT / UPDATE */}
    <div className="col-auto">
      <button
        type="submit"
        className="btn btn-primary px-4"
      >
        {isEditMode
          ? "Update Details"
          : "Submit Details"}
      </button>
    </div>

  </div>

</div>

        </div>
      </div>
    </form>
  </div>
)}

            </div>



          </>
        ) : (
          <>
            {/* TOP BAR */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "15px",
                padding: "15px",
              }}
            >
              {/* TITLE */}
              <h2
                style={{
                  color: "#1ba0c9",
                  margin: 0,
                }}
              >
                PURCHASE HISTORY
              </h2>

              {/* SEARCH BOXES */}
              <div
                style={{
                  display: "flex",
                  gap: "12px",
                  flexWrap: "wrap",
                  justifyContent: "flex-end",
                }}
              >
                <SearchBox
                  placeholder="Party Name / Number"
                  value={partySearchTerm}
                  onChange={(e) => setPartySearchTerm(e.target.value)}
                />
                <SearchBox
                  placeholder="Invoice Number"
                  value={invoiceSearch}
                  onChange={(e) => setInvoiceSearch(e.target.value)}
                />
              </div>
            </div>

            {/* TABLE WRAPPER */}
            <div style={{ overflowX: "auto", padding: "0 15px" }}>

              <div className="px-3">
                <div className="table-responsive bg-white shadow-sm rounded">

                  <table className="table table-hover mb-0">

                    {/* HEADER */}
                    <thead className=" text-center">
                      <tr >
                        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }} >SN</th>
                        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Party Name</th>
                        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Date</th>
                        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Total </th>
                        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Paid</th>

                        <th style={{ backgroundColor: "var(--primary-color)", color: "#fff" }}>Activity</th>
                      </tr>
                    </thead>

                    {/* BODY */}
                    <tbody className=" text-center">
                      {filteredPrucase.length === 0 ? (
                        <tr>
                          <td colSpan="7" className="text-center text-muted py-4">
                            No Party Found
                          </td>
                        </tr>
                      ) : (
                        filteredPrucase.map((item, index) => (
                          <tr key={item.id}>
                            <td>{purchaseBill.length - index}</td>
                            <td>{item.name}</td>
                            <td>{item.date}</td>

                            <td>{item.payable} </td>
                            <td>{item.received} </td>
                         

                            <td>
  {/* <button
    className="btn btn-link p-0 me-2"
    onClick={() => handleViewItems(item)}
  >
    <IoEye size={24} className="text-secondary" />
  </button> */}

{Number(item.itemsAdded) === 0 ? (
  <button
    type="button"
    className="btn btn-success btn-sm me-2"
    onClick={() => handleAddPurchaseItems(item)}
  >
    Add Items
  </button>
) : (
  <button
    type="button"
    className="btn btn-secondary btn-sm me-2"
    disabled
  >
    Added
  </button>
)}

    {item.itemsAdded == 0 &&( 
<CiEdit size={26} className="text-danger " title="Edit"  onClick={() =>
                            navigate("/Addpurchase", {
                              state: item,
                            })
                          }  />
    )}



</td>
                          </tr>
                        ))
                      )}
                    </tbody>

                  </table>

                  {showModal && (
                    <div className="modal fade show d-block" tabIndex="-1">
                      <div className="modal-dialog modal-lg modal-dialog-centered">

                        <div className="modal-content">

                          {/* Header */}
                          <div className="modal-header">
                            <h5 className="modal-title">Purchase Items</h5>

                            <button
                              type="button"
                              className="btn-close"
                              onClick={() => (setShowModal(false))}
                            />
                          </div>

                          {/* Body */}
                          <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                            <table className="table table-sm table-bordered">
                              <thead className="table-light">
                                <tr>
                                  <th>#</th>
                                  <th>Item</th>
                                  <th>Qty</th>
                                  <th>Purchase</th>
                                  <th>Sale</th>
                                  <th>Tax %</th>
                                  <th>Total</th>
                                </tr>
                              </thead>

                              <tbody>
                                {itemList.map((item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.name}</td>
                                    <td>{item.qty}</td>
                                    <td>₹{item.pur_price}</td>
                                    <td>₹{item.sale_price || 0}</td>
                                    <td>{item.taxRate}%</td>
                                    <td>₹{item.amount}</td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Footer */}
                          <div className="modal-footer">
                            <button
                              className="btn btn-secondary"
                              onClick={() => {
                                setShowModal(false);
                                resetForm();
                              }}
                            >
                              Close
                            </button>
                          </div>

                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>





            </div>
          </>
        )}
      </div>
    </div>
  );
};

const SearchBox = ({ placeholder, value, onChange }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      border: "2px solid #ff5d94",
      borderRadius: "8px",
      overflow: "hidden",
      background: "#fff",
      flex: "1",
      minWidth: "220px",
    }}
  >
    <input
      type="text"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      style={{
        border: "none",
        outline: "none",
        padding: "8px 12px",
        width: "100%",
        width: "100%",
        minWidth: "150px",
      }}
    />

    <div
      style={{
        padding: "0 10px",
        color: "#1d8cf8",
      }}
    >
      <FaSearch />
    </div>
  </div>
);

const MenuCard = ({ title, icon, bg, active, onClick }) => (
  <div
    onClick={onClick}
    style={{
      width: "100%",
      minHeight: "90px",
      background: bg,
      color: "#fff",
      padding: "15px",
      borderRadius: "12px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      border: active ? "4px solid #ff3d7f" : "none",
      transform: active ? "scale(1.03)" : "scale(1)",
      transition: "0.3s",
      boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
    }}
  >
    <h3
      style={{
        margin: 0,
        fontSize: "18px",
        whiteSpace: "nowrap",
      }}
    >
      {title}
    </h3>

    {icon}
  </div>
);


export default Purchase;